import ForgotPasswordForm from "components/modules/auth/ForgotPasswordForm";
import AuthCardLayout from "layouts/AuthCardLayout";

const ForgotPassword = () => {
  return (
    <>
      <style>
        {`
          @media (max-width: 500px) {
            .auth-card-container .col-lg-5.col-xl-4 {
              min-height: 330px !important;
            }
          }
        `}
      </style>
      <div className="auth-card-container">
        <AuthCardLayout>
          <ForgotPasswordForm />
        </AuthCardLayout>
      </div>
    </>
  );
};

export default ForgotPassword;
